<template>
  <div>
    <el-drawer
      title="上传视频"
      size="1300px"
      append-to-body
      :visible="selectYoutubeVideoShow"
      @close="close"
      @opened="openInit"
    >
      <div class="flex flex-col h-full youtubeVideos">
        <el-form
          :model="accountParams"
          label-width="100px"
          :inline="true"
          class="youtubeForm"
        >
          <YouTubeAccount
            ref="youtubeAccount"
            v-model="accountParams"
            @change="changeChannel"
          />
          <el-form-item label="">
            <el-input
              v-model="videoTitle"
              placeholder="请输入视频标题筛选"
              @blur="changeChannel"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="p-2 flex-1 pb-[50px] box-border flex-col flex h-[95%]">
          <div class="h-full overflow-auto">
            <el-form>
              <el-form-item label="">
                <el-checkbox-group
                  v-model="checkList"
                  class="flex-1 overflow-hidden"
                  v-if="videoList.length"
                >
                  <el-checkbox
                    v-for="(video, index) in videoList"
                    :key="video.id"
                    :label="video.id"
                    class="m-1 relative w-[192px] p-[6px]  videoItem inline-block !mr-[8px] align-top"
                  >
                    <!-- youtube 视频展示 -->
                    <youtube
                      :video-id="video.videoId"
                      v-bind="params"
                      @ready="ready"
                      class="w-full h-full border"
                    ></youtube>
                    <div class="py-2">
                        <el-tooltip effect="dark" :content="video.videoTitle" placement="top">
                            <p class="text-[#333] text-[14px] line-clamp-1 break-all text-ellipsis">{{ video.videoTitle }}</p>
                        </el-tooltip>
                        <p class="text-[#999] text-[13px] mt-[6px] flex items-center justify-between">
                          <span>{{ video.duration || '--'}}s</span>
                            <span>{{ video.createTime }}</span>
                            
                        </p>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
                <el-empty
                  v-else
                  description="暂无数据，请先选择频道"
                  class="h-full"
                ></el-empty>
              </el-form-item>
            </el-form>
          </div>

          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            class="text-right"
            :current-page="pageMsg.page"
            :page-sizes="[30, 50, 100]"
            :page-size="pageMsg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <div class="absolute right-3 bottom-5">
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="sure"
          >确 定</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>
<script>
import YouTubeAccount from '@/views/google/components/YouTubeAccount/index.vue';
import { videoPage } from '@/api/google/youtube';
export default {
  components: { YouTubeAccount },
  props: {
    //弹窗的显示隐藏
    selectYoutubeVideoShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      accountParams: {
        channelId: '',
      },
      videoList: [],
      checkList: [],
      params: {
        'player-width': 176,
        'player-height': 176,
      },
      total: 0,
      videoTitle: '',
      pageMsg: {
        page: 1,
        pageSize: 30,
      },
    };
  },
  methods: {
    ready(event) {
      console.log(event.target, 'event.targetevent.target');
    },
    /**
     * 打开弹窗
     */
    openInit() {
      this.checkList = [];
      this.$refs.youtubeAccount.getChannel();
    },
    /**
     * 选择频道
     */
    changeChannel(v) {
      this.pageMsg.page = 1;
      this.getList();
    },
    /**
     * 关闭弹窗
     */
    close() {
      this.accountParams.channelId = null;
      this.videoList = [];
      this.$emit('update:selectYoutubeVideoShow', false);
    },
    /**
     * 切换一页的条数
     */
    handleSizeChange(v) {
      this.pageMsg.pageSize = v;
      this.getList();
    },
    /**
     * 切换页数
     */
    handleCurrentChange(v) {
      this.pageMsg.page = v;
      this.getList();
    },
    /**
     * 获取视频列表
     */
    getList() {
      this.videoList = [];
      if (!this.accountParams.channelId) {
        return;
      }
      this.$showLoading();
      videoPage({ youtubeChannelId: this.accountParams.channelId, ...this.pageMsg, videoTitle: this.videoTitle }).then(
        (res) => {
          this.$hideLoading();
          this.videoList = res.data.list;
          this.total = res.data.total;
        },
      );
    },
    /**
     * 点击确定
     */
    sure() {
      const list = this.videoList.filter((v) => this.checkList.includes(v.id));
      this.$emit('updateValue', list);
      this.close();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  position: relative;
  padding: 20px;
}
::v-deep .videoItem {
  background-color: #f5f5f5;
  border-radius: 8px;
  .el-checkbox {
    margin-right: 0;
  }
  .el-checkbox__input {
    position: absolute;
  }
  .el-checkbox__label {
   width: 100%;
    padding-left: 0;
  }
}

</style>
<style lang="scss">
.youtubeVideos .el-input__inner {
  border-color: #dcdfe6 !important; /* 取消红色边框 */
  box-shadow: none !important; /* 取消红色阴影 */
}
</style>
